var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconStairsUp = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6.14401 5.28352H8.63101L3.97425 9.94027C3.675 10.2395 3.675 10.7255 3.97425 11.0248C4.2735 11.324 4.7595 11.324 5.05875 11.0248L9.71551 6.36802V8.85502C9.71551 9.27877 10.059 9.62227 10.4828 9.62227C10.9065 9.62227 11.25 9.27877 11.25 8.85502V4.51627C11.25 4.09252 10.9065 3.74902 10.4828 3.74902H6.14401C5.72025 3.74902 5.37675 4.09252 5.37675 4.51627C5.37675 4.94002 5.72025 5.28352 6.14401 5.28352Z", fill: "black" }),
            React.createElement("path", { d: "M17.25 6.75C16.4213 6.75 15.75 7.42125 15.75 8.25V11.25H12C11.1712 11.25 10.5 11.9212 10.5 12.75V15.75H7.5C6.67125 15.75 6 16.4213 6 17.25V20.25C6 20.664 6.336 21 6.75 21C7.164 21 7.5 20.664 7.5 20.25V17.25H10.5C11.3288 17.25 12 16.5787 12 15.75V12.75H15.75C16.5787 12.75 17.25 12.0788 17.25 11.25V8.25H21C21.414 8.25 21.75 7.914 21.75 7.5C21.75 7.086 21.414 6.75 21 6.75H17.25Z", fill: "black" }))),
        alt: 'StairsUp',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconStairsUp;
//# sourceMappingURL=index.js.map